app.controller('CIFDashboard-CTRL', function ($scope, $rootScope, $routeParams, uibDateParser, $uibModal, $http, $window, $location, $timeout, Upload, $q, $filter) {

    $scope.CIFInvestor = {}
    $scope.clientURL = 'https://oa.erdikha.com/FileKYC/';
    $scope.page = '';

    $scope.datanasabah = function () {
        $window.location.href = "#/profile";
    }

    $scope.stepClass = ['', 'blur', 'blur', 'blur', 'blur'];

    $scope.active = "active current";

    $scope.imgMale = "";
    $scope.imgFemale = "";
    $scope.chkquestionfatca = 2;

    var allPromise = $q.all([
        $http({
            method: 'POST',
            url: '/service/client.svc/retrieveSession',
        }).then(function (data) {
            if (!data.data.d) {
                $http({
                    method: 'GET',
                    url: '/service/client.svc/SignOut',
                }).then(function (data) {
                    if (data.data.d == true) {
                        $window.location.href = "#/login";
                        $window.location.reload();
                    }
                }, function (error) { })
            }
            else
                $scope.currentUser = data.data.d;
        }, function (error) { }),

        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFCountry',
            cache: true,
        }).then(function (data) {
            $scope.ListNationality = data.data.d;
        }, function (error) { }),

        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFCountryAll',
            cache: true,
        }).then(function (data) {
            $scope.ListCountry = data.data.d;
        }, function (error) { }),

        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFProvinceCity',
            cache: true,
        }).then(function (data) {
            $scope.ListProvinceCity = data.data.d;
        }, function (error) { }),

        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFLookup',
            cache: true,
        }).then(function (data) {
            $scope.ListLookup = data.data.d;
            if ($scope.ListLookup) {
                $scope.ListReligion = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Religion' }, true);
                $scope.ListMarital = $filter('filter')($scope.ListLookup, { CIFLookupID: 'MaritalStatus' }, true);
                $scope.ListEducation = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Educational' }, true);
            }
        }, function (error) { }),

        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFBank',
            cache: true,
        }).then(function (data) {
            $scope.ListBank = data.data.d;
        }, function (error) { }),
    ]);


    allPromise.then(function () {
        $http({
            method: 'GET',
            url: '/service/client.svc/getCIFDetail',
        }).then(function (data) {
            if (data.data.d != null) {
                var obj = data.data.d;
                $scope.CIFInvestor = data.data.d;
                $scope.CIFInvestor.QuestionRDN = "BANK CENTRAL ASIA";
                $scope.filenameKTP = $scope.CIFInvestor.KTPFile;
                $scope.filenameFotoDiri = $scope.CIFInvestor.SelfieFile;
                $scope.filenameTandaTangan = $scope.CIFInvestor.TandaTanganFile;

                if ($scope.filenameKTP) {

                    if (!$scope.filenameKTP.endsWith(".pdf")) {
                        $http({
                            method: 'GET',
                            url: 'FileKYC/' + $scope.filenameKTP,
                            responseType: 'blob',

                        }).then(function (response) {
                            $scope.KTPFile = [];
                            $scope.KTPFile.push(response.data);
                        }, function (response) {
                            $scope.saveErrors = true;
                            $scope.errorMessages = {
                                text: 'File tidak ketemu atau terhapus dari server!!!',
                            };
                            $timeout(function () {
                                $scope.saveErrors = false;
                            }, 3000);
                        });
                    }
                };

                if ($scope.filenameFotoDiri) {

                    if (!$scope.filenameFotoDiri.endsWith(".pdf")) {
                        $http({
                            method: 'GET',
                            url: 'FileKYC/' + $scope.filenameFotoDiri,
                            responseType: 'blob',
                        }).then(function (response) {
                            $scope.fotodiriFile = [];
                            $scope.fotodiriFile.push(response.data);
                        }, function (response) {
                            $scope.saveErrors = true;
                            $scope.errorMessages = {
                                text: 'File tidak ketemu atau terhapus dari server!!!',
                            };
                            $timeout(function () {
                                $scope.saveErrors = false;
                            }, 3000);
                        });
                    }
                };
                if ($scope.filenameTandaTangan) {

                    if (!$scope.filenameTandaTangan.endsWith(".pdf")) {
                        $http({
                            method: 'GET',
                            url: 'FileKYC/' + $scope.filenameTandaTangan,
                            responseType: 'blob',

                        }).then(function (response) {
                            $scope.tandatanganFile = [];
                            $scope.tandatanganFile.push(response.data);
                        }, function (response) {
                            $scope.saveErrors = true;
                            $scope.errorMessages = {
                                text: 'File tidak ketemu atau terhapus dari server!!!',
                            };
                            $timeout(function () {
                                $scope.saveErrors = false;
                            }, 3000);
                        });
                    }
                };


                if ($scope.CIFInvestor.Sex) {
                    if ($scope.CIFInvestor.Sex == 'Male') {
                        $scope.imgMale = "../img/svg/report-male.svg";
                    }

                    if ($scope.CIFInvestor.Sex == "Female") {
                        $scope.imgMale = "../img/svg/report-animate.svg";
                    }
                }

                if ($scope.CIFInvestor.FATCA1 == 'Tidak' || $scope.CIFInvestor.FATCA2 == 'Tidak' || $scope.CIFInvestor.FATCA3 == 'Tidak') {
                    $scope.chkquestionfatca = 1;
                }

                if ($scope.CIFInvestor.State1)
                    $scope.stepClass[1] = "active current";

                if ($scope.CIFInvestor.State2)
                    $scope.stepClass[2] = "active current";

                if ($scope.CIFInvestor.State3)
                    $scope.stepClass[3]= "active current";

                if ($scope.CIFInvestor.State4)
                    $scope.stepClass[4] = "active current";

                if ($scope.CIFInvestor.IsFinished == 1)
                {
                    $scope.page = 'finished'
                    
                }
                if ($scope.CIFInvestor.IsRevised == 1) {
                    $scope.page = 'revised'
                }
                console.log('test-dashboard', $scope.page);
            } // END IF data.data.d
        }, function (error) { });
    });

    console.log('page', $scope.page);

    $scope.login = function () {
        $window.location.href = "#/cif/data-pribadi";
    }

    $scope.logOff = function () {
        $http({
            method: 'POST',
            url: '/service/client.svc/logOff',
        }).then(function (data) {
            console.log(data);
            if (data.data.d == true) {
                $window.location.href = "#/login";
                $window.location.reload();
            }
        }, function (error) { })
    };

});